/**
 * Chat Type Definitions
 */

export enum MessageRole {
  USER = "user",
  ASSISTANT = "assistant",
  SYSTEM = "system",
}

export interface ChatMessage {
  id: string;
  session_id: string;
  role: MessageRole;
  content: string;
  metadata?: {
    intent?: string;
    job_type?: string;
    job_id?: string;
    job_number?: string;
    confidence?: number;
    session_title?: string;  // For updating session title in sidebar
    // Extended fields for rich messages
    query_type?: string;
    show_images?: boolean;
    uploaded_image?: string;
    job_data?: {
      id: string;
      job_number?: string;
      job_type: string;
      status: string;
      input_file_path?: string;
      annotated_output_path?: string;
      results?: Record<string, any>;
      completed_at?: string;
    };
  };
  created_at: string;
}



export interface ChatSession {
  id: string;
  user_id: string;
  title: string | null;
  is_active: boolean;
  llm_provider: string | null;
  llm_model: string | null;
  created_at: string;
  last_message_at: string;
  message_count: number;
}

export interface ChatHistory {
  session: ChatSession;
  messages: ChatMessage[];
}
